import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { TablerIconsModule } from "angular-tabler-icons";
import { LandingSectionRevealDirective } from "../../shared/landing-section-reveal.directive";
import { LANDING_1_FEATURES } from "../../landing-1.section-data";

@Component({
  selector: "app-landing-1-features",
  standalone: true,
  imports: [TranslateModule, TablerIconsModule, LandingSectionRevealDirective],
  templateUrl: "./landing-1-features.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Landing1FeaturesComponent {
  readonly features = LANDING_1_FEATURES;
}
